import { render, staticRenderFns } from "./videoByLink.vue?vue&type=template&id=92c7073a&scoped=true"
import script from "./videoByLink.vue?vue&type=script&lang=js"
export * from "./videoByLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92c7073a",
  null
  
)

export default component.exports